import script from "./blog-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./blog-detail.vue?vue&type=script&setup=true&lang=js"

import "./blog-detail.vue?vue&type=style&index=0&id=05165018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05165018"]])

export default __exports__